/*
 *
 * ManageRolePermissions constants
 *
 */

export const DEFAULT_ACTION = 'app/ManageRolePermissions/DEFAULT_ACTION';
